import { getFunctions, httpsCallable } from 'firebase/functions';

// ============================================================================
// Shared by the InMocean Work and Agents screens (CHA-622 Playbooks, CHA-587 agent config).
// ============================================================================
// This shell names its own tenant (Path 1; generalization deferred to CHA-25), as WorkHome/useRuns do.
export const TENANT_ID = 'inmocean';

// Who may see the admin configuration panels. Mirrors the gateway's gate
// (requireTenantAdminOrPlatformAdmin): a platform admin, or this tenant's admin. The server enforces it
// regardless; this only keeps the panels away from roles that could not save anyway.
export const canAdminTenant = (profile) => {
  const role = profile?.role;
  if (role === 'platform_owner' || role === 'platform_admin') return true;
  return role === 'admin' && profile?.tenantId === TENANT_ID;
};

// Call the auth-gated yulieTicketAction gateway for this tenant and RETURN its data. A platform admin
// must name the tenant (resolveTenant); a tenant-scoped caller's value is ignored server-side.
export const callWorkGateway = async (payload) => {
  const fn = httpsCallable(getFunctions(), 'yulieTicketAction');
  const res = await fn({ ...payload, tenantId: TENANT_ID });
  return res?.data;
};
